import * as yup from 'yup';
import { FEEDBACK_VALIDATION } from '../constants/feedback';
import { MAX_NICKNAME_LENGTH } from './generateXIDSchema';
export const MAX_SURVEY_COMMENT_LENGTH = 1000;
export const feedbackSchema = () => {
  return yup
    .object({
      firstName: yup
        .string()
        .required(FEEDBACK_VALIDATION.FIRST_NAME_REQUIRED)
        .max(MAX_NICKNAME_LENGTH, FEEDBACK_VALIDATION.FIRST_NAME_INVALID),
      emailAccount: yup
        .string()
        .required(FEEDBACK_VALIDATION.EMAIL_REQUIRED)
        .matches(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
          {
            message: FEEDBACK_VALIDATION.EMAIL_INVALID,
            excludeEmptyString: false
          }
        ),
      phoneNumber: yup
        .string()
        .optional()
        .matches(
          /^(\d{3})-(\d{3})-(\d{4})$/,
          { message: FEEDBACK_VALIDATION.PHONE_NUMBER_INVALID, excludeEmptyString: true }
        ),
      surveyComment: yup
        .string()
        .max(MAX_SURVEY_COMMENT_LENGTH, FEEDBACK_VALIDATION.FEEDBACK_INVALID),
    })
  .required();
};
